import React from 'react';

const HomeBackground = () => (
  <div className="home-bg" aria-hidden="true">
    <div className="home-bg__grid" />
    <div className="home-bg__vignette" />

    <div className="home-bg__fx-wash" />
    <div className="home-bg__fx-blob home-bg__fx-blob--a" />
    <div className="home-bg__fx-blob home-bg__fx-blob--b" />
    <div className="home-bg__fx-blob home-bg__fx-blob--c" />
    <div className="home-bg__fx-ring home-bg__fx-ring--1" />
    <div className="home-bg__fx-ring home-bg__fx-ring--2" />
    <div className="home-bg__fx-beam home-bg__fx-beam--1" />
    <div className="home-bg__fx-beam home-bg__fx-beam--2" />
    <div className="home-bg__fx-beam home-bg__fx-beam--3" />

    <div className="home-bg__fx-dots">
      {Array.from({ length: 22 }).map((_, i) => (
        <span
          key={i}
          className="home-bg__fx-dot"
          style={{
            left: `${(i * 4.5 + 3) % 100}%`,
            animationDuration: `${10 + (i % 6) * 2.5}s`,
            animationDelay: `${(i * 0.6) % 12}s`,
          }}
        />
      ))}
    </div>

    <svg className="home-bg__chart" viewBox="0 0 400 120" preserveAspectRatio="none">
      <defs>
        <linearGradient id="homeChartGrad" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" stopColor="rgba(37, 99, 235,0)" />
          <stop offset="45%" stopColor="rgba(37, 99, 235,0.22)" />
          <stop offset="100%" stopColor="rgba(29, 78, 216,0.35)" />
        </linearGradient>
      </defs>
      <path
        className="home-bg__chart-line"
        d="M0,90 L40,75 L80,82 L120,55 L160,62 L200,38 L240,48 L280,28 L320,35 L360,18 L400,25"
        fill="none"
        stroke="url(#homeChartGrad)"
        strokeWidth="1.5"
      />
      <path
        className="home-bg__chart-area"
        d="M0,90 L40,75 L80,82 L120,55 L160,62 L200,38 L240,48 L280,28 L320,35 L360,18 L400,25 L400,120 L0,120 Z"
        fill="url(#homeChartGrad)"
        opacity="0.04"
      />
    </svg>
  </div>
);

export default HomeBackground;
